import { Component } from '@angular/core';

@Component({
  selector: 'vl-app',
  templateUrl: 'app.component.html'
})
export class AppComponent {}
